<!--
     <FilterAdvanced
       :filters='QFilters'
       @update="my_update_handler(QFilters)"
       disabled
     />
-->

<template>
  <div>
    <v-btn
      v-if="!is_mobile"
      @click.stop="showHeadFilters"
      class="qmkey-btn-avanced-filters"
      :class="[
        active ? 'qmkey-btn-avanced-filters-active' : '',
        props.activator_class ? props.activator_class : 'no-activator-class',
      ]"
      :color="active ? '#7a5bc3' : ''"
      :disabled="disabled"
    >
      {{ $vuetify.lang.translator('filters.advanced.filters') }}
      <v-icon right class="icon-large">mdi-tune-vertical</v-icon>
    </v-btn>

    <v-btn
      v-else
      @click.stop="showHeadFilters"
      :disabled="disabled"
      icon
      small
    >
      <v-icon class="qmkey-mobile-advanced-icon" small>mdi-tune-vertical</v-icon>
    </v-btn>

    <!-- Add /edit dialog -->
    <v-dialog
      id="headfilters"
      max-width="400px"
      ref="headfilters"
      v-model="showFilterForm"
      @keydown.esc="close"
      persistent
    >
      <v-card
        class="mx-auto">

        <v-card-title>
          <span class="qmkey-modal-h1 pb-0">{{ $vuetify.lang.translator('filters.advanced.title') }}</span>
          <v-spacer></v-spacer>
          <v-btn class="qmkey-modal-dialog-close" text plain right small :ripple="false" @click="close">
            <v-icon :ripple="false" small>mdi-close</v-icon>
          </v-btn> 
        </v-card-title>

        <v-card-text class="pt-3">
          <DynamicForm
            ref="dform"
            :fields="dfields"
            :return_object="true"
          />
        </v-card-text>

        <v-card-actions class="qmkey-modal-dialog-card-actions">
          <v-spacer></v-spacer>
          <v-btn @click="cancelHeadFilters"
            class="qmkey-modal-dialog-button-secondary"
          >
            {{ $vuetify.lang.translator('dialog.clear') }}
          </v-btn>
          <v-btn
            class="qmkey-modal-dialog-button-submit"
            @click="setHeadFilters"
          >
            {{ $vuetify.lang.translator('dialog.send') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>


<style lang="scss">
 @import "@/sass/explorer.scss";
 @import "@/sass/modalform.scss";
</style>


<script>
 import QUnit from '@/api/QUnit'
 import DynamicForm from '@/components/DynamicForm.vue'
 import { QFilters, get_qfilter } from '@/qunit/filters';

 export default {
   components: {
     DynamicForm,
   },

   name: 'FilterAdvanced',

   props: {
     filters: {
       type: QFilters,
       required: true,
     },
     disabled: {
       type: Boolean,
       required: false,
       default: false
     },
     is_mobile: {
      type: Boolean, 
      default: false
    },
     props: {
      default: () => ({})
     }
   },

   data: () => ({
     filter_fields_to_collect: [],
     showFilterForm: false,
     dfields: [[]],
     raw_fields: null,
     saved_filters: null,
   }),

   computed: {
     business_process() {
       return this.filters.get_filter_value('business_process');
     },

     centro_id() {
       return this.filters.get_filter_value('centro');
     },

     active() {
       // return Object.keys(this.filters.advanced_filters||{}).length > 0;
       return Object.values(this.filters.get_filter_value('advanced_filters')||{}).some((elem) => elem != undefined)
     },
   },

   mounted() {
     this.pull_filters();
   },

   methods: {
     close() {
       this.showFilterForm = false;
     },

     cancelHeadFilters() {
       this.$refs.dform.clear();
     },

     setHeadFilters() {
       const form_data = this.$refs.dform.get_data();
       const values = {};

       for (const field of this.filter_fields_to_collect) {
         values[field.id] = undefined;
       }
       for (const [key, value] of Object.entries(form_data)) {
         values[key] = value;
       }
       let filters = new QFilters();
       filters.set_filter(get_qfilter('advanced_filters',values));
       this.$emit("update", filters);
       this.saved_filters = filters
       this.close();     
     },

     async query_fields() {
       if (! this.business_process) {
         this.set_filter_fields_to_collect();
       } else {
         const data = await QUnit.getFieldsToCollectForFiltering(this.centro_id, this.business_process);
         this.set_filter_fields_to_collect(data.fields);
       }
     },

     showHeadFilters() {
       this.showFilterForm = true;
     },

     set_filter_fields_to_collect(fields) {
       this.raw_fields = fields;
       this.update_fields_values();
     },

     update_fields_values() {
      const active_filters = Object.assign({}, ...this.filter_fields_to_collect.map((x) => ({[x.id]: x.value})));
       this.filter_fields_to_collect = [];
       const adv_filters = this.filters.get_filter_value('advanced_filters')
       // Reflect active filters:
       for (const field of (this.raw_fields || [])) {
         this.filter_fields_to_collect.push({
           ...field,
           value: (active_filters[field.id] !== undefined && adv_filters && adv_filters[field.id]) ? active_filters[field.id] : undefined,
           cols: 12,
         });
       }

       this.dfields = this.filter_fields_to_collect.map(f => [f]);
     },

     pull_filters() {
       // TODO
       this.update_fields_values();
       this.query_fields();
     },

     get_value() {
      return this.saved_filters;
     },
   },

   watch: {
     filters() {
       this.pull_filters();
     },
   }
 }
</script>
